<template>
    <div v-if="fields.length > 0" class="assumed-fields-note mt-2">
        <v-icon x-small class="mr-1 assumed-fields-note__icon">mdi-information-outline</v-icon>
        {{ $t('ai.assumed_fields_label') }}
        <span v-for="(field, i) in fields" :key="field">
            {{ $t(`ai.assumed_field_${field}`) }}<template v-if="i < fields.length - 1">, </template>
        </span>
    </div>
</template>

<script>
export default {
    name: 'AiAssumedFieldsNote',
    props: {
        fields: {
            type: Array,
            default: () => [],
        },
    },
}
</script>

<style scoped>
.assumed-fields-note {
    font-size: var(--fs-caption);
    line-height: 1.4;
    color: var(--v-txtMuted-base);
}

.assumed-fields-note__icon {
    color: var(--v-txtMuted-base) !important;
}
</style>
